import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import 'mapbox-gl/dist/mapbox-gl.css';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme.js';
import ErrorBoundary from './features/errors/ErrorBoundary';

const root = createRoot(document.getElementById('root'));

root.render(
    <StrictMode>
        <ErrorBoundary>
            <HelmetProvider>
                <ThemeProvider theme={theme}>
                    <BrowserRouter>
                        {AppRoutes}
                    </BrowserRouter>
                </ThemeProvider>
            </HelmetProvider>
        </ErrorBoundary>
    </StrictMode>
);
